import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../AuthContext";
import "../../styles/main.css";

const Redirecting: React.FC = () => {
  const navigate = useNavigate();
  const {user, loading} = useAuth();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // If user is loaded and not loading, check verification and redirect
    if (user && !loading) {
      // Check if user's email is verified
      if (user.isEmailVerified === false) {
        navigate("/auth/email-verification", {replace: true});
      } else {
        navigate("/overview", {replace: true});
      }
      return;
    }

    // Countdown timer for manual redirect
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          // Check verification before final redirect
          if (user && user.isEmailVerified === false) {
            navigate("/auth/email-verification", {replace: true});
          } else {
            navigate("/overview", {replace: true});
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [user, loading, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>Welcome to The League!</h1>
          <p>Setting up your account...</p>
        </div>

        <div className="auth-content">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>

          <div className="redirect-message">
            <p>Please wait while we set up your account.</p>
            <p>You will be automatically redirected to your dashboard.</p>
          </div>

          <div className="manual-redirect">
            <p>
              If you are not redirected automatically,{" "}
              <button
                className="link-button"
                onClick={() => {
                  if (user && user.isEmailVerified === false) {
                    navigate("/auth/email-verification", {replace: true});
                  } else {
                    navigate("/overview", {replace: true});
                  }
                }}
              >
                click here
              </button>{" "}
              in {countdown} seconds.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Redirecting;
